import React from 'react';
import '../../../App.scss';
import 'antd/dist/antd.css';
import { Alert, PageHeader, Spin } from 'antd';

import { useTeamTags, useTeamDetails } from '../../../models/useTeamTags';
import { StrikeTagsListView } from '../../../components/client/StrikeTagsListView';

/**
 * Team tags & devices — functional + hooks (migrated from the
 * StrikeTeamTagsModel/StrikeTeamDetailsModel viewModel-callback wiring;
 * house rule: screens we touch migrate in the same change).
 */
const TeamTagsScreen = (props) => {
  const { teamId } = props.match.params;
  const { isAdmin, match } = props;
  const [teamLoading, team] = useTeamDetails(teamId);
  const [tagsLoading, tags, tagsError, { updateTag }] = useTeamTags(teamId);

  const onEditTeamTag = async (tag, updatedTagData) => updateTag(tag.id, updatedTagData);

  return (
    <div style={{ height: '100%', textAlign: 'center' }}>
      <PageHeader
        ghost={false}
        title={team ? `${team.teamName}` : 'Team Tags'}
        onBack={() => window.history.back()}
      />
      {tagsError && <Alert type="error" showIcon message={tagsError} style={{ margin: '12px' }} />}
      {(teamLoading || tagsLoading) ? <Spin style={{ marginTop: '48px' }} /> : (
        <StrikeTagsListView
          data={tags}
          onEditTag={onEditTeamTag}
          team={team}
          isAdmin={!!isAdmin}
          match={match}
        />
      )}
    </div>
  );
};

export default TeamTagsScreen;
